export default "__VITE_ASSET__psA8laqU__"